module.exports = __webpack_public_path__ + "static/img/preview-03.8730a033.webp";